<template>
  <b-row>
    <b-col md="12" ref="tableContainer" id="tableContainer">
      <b-table
        ref="responsiveTable"
        :items="items"
        responsive
        :fields="fields"
        row-details="rowDetails"
        :sort-compare="sortCompare"
        :current-page="currentPage"
        :per-page="perPage"
        striped
        hover
        small
        @refreshed="responsiveRefresh"
        :sort-by.sync="sortByInner"
        :sort-desc.sync="sortDescInner"
      >
        <template v-slot:cell(show_details)="row" ref="show_details" class="show_details">
          <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
          <b-button
            v-if="respTable.showTool==1"
            size="sm"
            @click.stop="row.toggleDetails"
            class="mr-2"
          >{{ row.detailsShowing ? '-' : '+'}}</b-button>
        </template>

        <template v-slot:row-details="row">
          <b-card class="rowDetail" v-if="rowDetails.length">
            <b-row v-for="detailX in rowDetails" v-bind:key="detailX.key">
              <b-col class="text-left col-6 col-md-3">
                <b>{{detailX.label}}:</b>
              </b-col>
              <b-col class="text-left col-6 col-md-9">
                <template
                  v-if="(typeof $scopedSlots[detailX.key] == 'undefined' )"
                >{{ (typeof detailX.formatter != "undefined")? detailX.formatter(row.item[detailX.key],detailX.key,row.item):row.item[detailX.key] }}</template>
                <template v-else>
                  <!-- hier wird ein slot namens "freigaben" bereitgestellt -->
                  <slot :name="detailX.key" v-bind="row" />
                </template>
              </b-col>
            </b-row>
          </b-card>
          <b-card v-else>
            <!-- ich kann row.toggleDetails einfach nicht von aussen ansteuern ..  -->
            <b-button size="sm" @click.stop="row.toggleDetails" class="mr-2">X</b-button>
          </b-card>
        </template>

        <!-- hier wird ein slot "cell(freigaben)" für die btable gefüllt wenn darin ein slot namens "freigaben" bereitgestellt ist -->
        <template v-for="(_, slot) of $scopedSlots" v-slot:[buildSlotName(slot)]="scope">
          <slot :name="slot" v-bind="scope" />
        </template>
      </b-table>
    </b-col>

    <b-col cols="6" v-if="(totalRows>perPage)">
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
    </b-col>
    <b-col cols="6" v-if="(totalRows>perPage)">
      <b-form-select :options="pageOptions" v-model="perPage" />
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: "tableResponsive",
  props: {
    items: Array,
    fieldDefinition: Array,
    sortCompare: Function,
    sortBy: String,
    sortDesc: Boolean,
    minLenght: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      fields: [{ key: "show_details", label: "", sortable: false }].concat(
        this.fieldDefinition.slice()
      ), // slice clones the array
      respTable: {
        showTool: 0,
        doRefresh: 0,
        refreshMaxIterations: 0
      },
      rowDetails: [],
      showLatest: [], //[] | ['showLatest']
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 25],
      totalRows: this.items.length,
      sortByInner: "MPDDATUM",
      sortDescInner: true,
      oldClientWith: 0
    };
  },
  computed: {},
  methods: {
    getRenderedScopedSlots(scopedSlots) {
      return scopedSlots;
    },
    buildSlotName(name) {
      return "cell(" + name + ")";
    },
    responsiveRefresh() {
      //beim ziehen am Browserfenster entstehen hunderte refresh Ereignisse, nur eines / sek verarbeiten ..
      if (this.respTable.doRefresh == 1) {
        if (this.respTable.refreshMaxIterations > 0) {
          setTimeout(this.responsiveWorker, 200);
        }
      } else {
        //start delayed refresh
        this.respTable.doRefresh = 1;
        this.respTable.refreshMaxIterations =
          this.fields.length + this.rowDetails.length;
        setTimeout(this.responsiveWorker, 500);
      }
    },
    responsiveWorker() {
      try {
        var scrollWidth =
          this.$el.querySelector(".table-responsive").scrollWidth || 1;
        var clientWidth = this.$refs.tableContainer.clientWidth - 30 || 1;
      } catch (e) {
        setTimeout(self.responsiveWorker, 100);
        return true;
      }

      if (this.respTable.refreshMaxIterations < 1) {
        this.respTable.doRefresh = 0;
      }

      if (this.respTable.doRefresh == 1) {
        this.respTable.refreshMaxIterations--;
        // dies ist eine endlosRecursion via this.updated () ein vuejs DOM-Trigger und diesem Worker der wiederum den Dom modifiziert.
        // die Tabelle wird vergrössert/verkleinert bis sie von der grösse her mit dem Parentelement übereinstimmt.
        // dann wird doRefresh == 0 gesetzt

        if (this.oldClientWith < clientWidth) {
          // ClientWidth hat mehr platz bekommen, Tabelle maximal vergrössern
          if (this.rowDetails.length) {
            this.rowDetails.forEach(element => {
              this.fields.push(element);
            });
            this.rowDetails = [];
            this.respTable.showTool = 0;
            this.oldClientWith = clientWidth;
            this.respTable.refreshMaxIterations = this.fields.length;
            return true; // abbruch damit die rekursin via Update stattfinden kann, nur so sind die breiten aktuell
          }
        }

        //clientwidt nachführen (wird immer kleiner)
        this.oldClientWith = clientWidth;

        if (scrollWidth > clientWidth && this.fields.length > this.minLenght) {
          //Tabelle verkleinern
          this.rowDetails.unshift(this.fields.pop());
          this.respTable.showTool = 1;
        }

        if (scrollWidth == clientWidth) {
          this.respTable.doRefresh = 0;
          return true;
        }
      }
    }
  },
  created() {
    let self = this;
    this.$nextTick(async function() {
      self.sortByInner = self.sortBy;
      self.sortDescInner = self.sortDesc;
      /**/
      // nach F5 refresh login via JWT müssen erst die Betriebe geladen werden async problem
    });
  },
  updated() {
    let self = this;
    this.$nextTick(async function() {
      //dies ist die Endlosrekursion mit dem responsiveRefresh
      if (self.respTable.doRefresh == 1) {
        self.responsiveWorker();
      }
    });
  },
  deactivated() {},
  beforeDestroy() {
    window.removeEventListener("resize", this.responsiveRefresh);
  },
  destroyed() {},
  errorCaptured() {},
  mounted() {
    window.addEventListener("resize", this.responsiveRefresh);
    this.responsiveRefresh();
  },
  components: {},
  watch: {
    items: function() {
      this.totalRows = this.items.length;
    },
    sortByInner: function(sortByInner) {
      this.$emit("update:sortBy", sortByInner);
    },
    sortDescInner: function(sortDescInner) {
      this.$emit("update:sortDesc", sortDescInner);
    },
    sortBy: function() {
      this.sortByInner = this.sortBy;
    },
    sortDesc: function() {
      this.sortDescInner = this.sortDesc;
    }
  }
};
</script>
<style>
table.table tbody td {
  white-space: nowrap;
}
table.table tbody td div.card.rowDetail {
  white-space: normal;
}
</style>
